export const typesEventCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Tipi Evento',
    path: '/sistema/eventmanager/tipievento',
  },
];
